import { AsyncPipe, NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, inject, Input, TemplateRef, ViewChild } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { IconComponent } from 'src/app/core/icon/icon.component';
import { IFundraiser } from '@models/fundraiser.model';
import { PaymentService } from '@services/payment/payment.service';
import { StorageService } from '@services/storage/storage.service';
import { UtilService } from '@services/util/util.service';
import { VariablesService } from '@services/variables/variables.service';
import { PaymentComponent } from '@common-components/payment/payment.component';
import { PaymentUtilService } from '@services/payment-util/payment-util.service';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AcknowledgeFormComponent } from 'src/app/core/acknowledge-form/acknowledge-form.component';
import { CustomTranslatePipe } from '@pipes/translate/translate.pipe';

@Component({
  selector: 'app-donation-methods-v2',
  standalone: true,
  imports: [
    CustomTranslatePipe,
    NgIf,
    NgFor,
    NgTemplateOutlet,
    AsyncPipe,
    IconComponent,
    MatRippleModule,
    PaymentComponent
  ],
  templateUrl: './donation-methods-v2.component.html',
  styleUrls: ['./donation-methods-v2.component.scss']
})
export class DonationMethodsV2Component {

  private readonly actRoute = inject(ActivatedRoute);
  private readonly dialog = inject(MatDialog);
  private readonly storage = inject(StorageService);
  private readonly util = inject(UtilService);
  private readonly paymentUtil = inject(PaymentUtilService);
  private readonly payment = inject(PaymentService);
  readonly vars = inject(VariablesService);

  @Input() fundraiser: IFundraiser;
  @Input() bankData: any;
  @Input() origin: string;
  @Input() showBeneficiary: boolean = false;
  @Input() openDonate = false;

  @ViewChild('paymentModule', { static: true }) public paymentModule: TemplateRef<HTMLElement>;

  upiOptions = [
    { mode: 'GooglePay', label: 'Google Pay' },
    { mode: 'PhonePe', label: 'PhonePe' },
    { mode: 'Paytm', label: 'Paytm' },
    { mode: 'Whatsapp', label: 'Whatsapp Pay' },
    { mode: 'BHIM', label: 'BHIM' },
  ];

  bankInfo = {
    account_number: '',
    name: '',
    ifsc: '',
    ifsc_character: '',
    accountType: ''
  };

  isMobile = this.vars.isMobile;
  qParams: any;
  isBtnClicked = false;
  isStoryPage = /stories|mini_story/.test(this.vars.pageName);

  ngOnInit() {
    this.openDonateNow();
    if (this.util.getMobileOperatingSystem() === 'iOS') {
      this.upiOptions = this.upiOptions.filter((item) => this.vars.iosSupportedIntent.includes(item.mode));
    } else {
      this.upiOptions = this.upiOptions.filter((item) => item.mode !== 'BHIM');
    }
  }

  ngOnChanges() {
    if (this.bankData) {
      this.setBankDetails();
    }
  }

  setBankDetails(data = this.bankData) {
    if (data && data.info_3) {
      const temp = data.info_3.split('|');
      this.bankInfo.account_number = temp[0];
      this.bankInfo.name = temp[1];
      this.bankInfo.ifsc = temp[2];
      if (temp[2]?.includes('0')) {
        const zeroIndex = temp[2].indexOf('0');
        this.bankInfo.ifsc_character = zeroIndex > 0 ? temp[2]?.[zeroIndex - 1] : "";
      }
    }
  }

  openDonateNow() {
    this.qParams = this.actRoute.snapshot.queryParams;
    const donateOpened = this.storage.getFromSession(`donateOpened-${this.fundraiser?.custom_tag}`) ? true : false;
    if (this.openDonate && this.qParams.donate && !donateOpened) {
      this.donateNow('onload');
      this.storage.addSessionData(`donateOpened-${this.fundraiser?.custom_tag}`, true);
    }
  }

  donateNow(mode: string) {
    this.isBtnClicked = true;

    if (!this.qParams?.sip_story) {
      this.paymentUtil.contributeInitiatedEvents(mode);
    }

    const supportedUPIModes = this.upiOptions.map(option => option.mode);
    if (supportedUPIModes.includes(mode)) {
      this.payment.selectedMode = 'UPI';
      this.payment.selectedModeValue = mode;
      this.payment.selectedPaymentModeLabel = this.upiOptions.find(option => option.mode === mode)?.label || '';
    }

    const useKKartClass = this.vars.showKCart && !this.isMobile && this.isStoryPage;
    const dialogRef = this.dialog.open(this.paymentModule, {
      width: '100vw',
      maxWidth: '660px',
      minHeight: '550px',
      height: this.isMobile ? '100vh' : 'auto',
      maxHeight: this.isMobile ? 'auto' : 'calc(100vh - 50px)',
      panelClass: useKKartClass ? ['payment-dialog', 'k-kart-pay'] : ['payment-dialog'],
      disableClose: true,
      closeOnNavigation: false
    });

    dialogRef.afterClosed().subscribe(() => {
      this.payment.selectedMode = '';
      this.payment.selectedModeValue = '';
      this.payment.selectedPaymentModeLabel = '';
    });
  }

  openAcknowlegementModal(type: string) {
    this.dialog.open(AcknowledgeFormComponent, {
      data: { mode: type },
      width: '100vw',
      height: '100vh',
      maxWidth: '600px',
      maxHeight: this.isMobile ? '100vh' : '550px',
    });
  }
}
